import script from "./LiveControlPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveControlPage.vue?vue&type=script&setup=true&lang=js"

import "./LiveControlPage.vue?vue&type=style&index=0&id=432da734&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-432da734"]])

export default __exports__